/** @format */

import { user_data } from "../../../../components/functions/usr";

export const hisobla = (data) => {
  const regionId = user_data() ? user_data().region_id : 0;
  if (regionId == 0) {
    return data;
  }

  switch (regionId) {
    case 1: {
      data = make(data, 163, [164, 165, 166, 167, 168]);
      data = make(data, 159, [160, 161, 162, 163]);
      data = make(data, 169, [171, 172, 173, 174, 175, 176]);
      data = make(data, 155, [158, 159, 169]);
      break;
    }
    case 2: {
      data = make(data, 264, [265, 266, 267]);
      data = make(data, 270, [271, 273, 274, 275, 276]);
      data = make(
        data,
        259,
        [264, 270, 278, 279, 283, 284, 285, 286, 287, 296]
      );
      data = make(data, 277, [278, 279, 280]);
      break;
    }
    case 3: {
      data = make(data, 86, [87, 88, 89, 90]);
      break;
    }
    case 4: {
      data = make(
        data,
        433,
        [437, 440, 443, 446, 449, 452, 455, 457, 458, 459, 460]
      );
      break;
    }
    case 5: {
      data = make(data, 41, [67, -68, -74, 76, 45, 47, 48, 49, 50]);
      data = make(data, 44, [67, -68, -74, 76]);
      break;
    }
    case 6: {
      data = make(data, 95, [96, 97, 98, 99, 100, -101, -102, 103, -104]);
      data = make(data, 91, [94, 95, 108, 109]);
      data = make(data, 105, [106, 107, 108, 109]);
      break;
    }
    case 7: {
      data = make(data, 315, [316, 317, 318]);
      data = make(data, 319, [320, 321, 322]);
      data = make(data, 325, [326, 327]);
      data = make(
        data,
        302,
        [307, 308, -310, 312, -313, 315, 319, 324, 325, 328, 329, 330]
      );
      break;
    }
    case 8: {
      data = make(
        data,
        189,
        [
          190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203,
          204, 205, 206, 207,
        ]
      );
      data = make(data, 254, [255, 256, 257, 258]);
      break;
    }
    case 9: {
      data = make(data, 421, [422, 423, 424]);
      data = make(data, 411, [415, 418, 421, 430, 431, 432]);
      break;
    }
    case 10: {
      data = make(data, 18, [19, 20, 21, 22, 23]);
      data = make(data, 4, [5, 8, 9]);
      data = make(data, 1, [4, 18, 40]);
      break;
    }
    case 11: {
      data = make(data, 384, [385, 386]);
      data = make(data, 394, [396, 397, 398, 399]);
      break;
    }
    case 12: {
      data = make(data, 355, [356, 357, 358]);
      data = make(
        data,
        348,
        [352, 353, 354, 355, 359, 360, 361, -362, 367, 368, 369]
      );
      break;
    }
    case 13: {
      data = make(data, 177, [180, 181, 182, 183, 184, 185]);
      break;
    }
    case 15: {
      data = make(data, 483, [484, 485, 486]);
      data = make(data, 497, [498, 499, 500, 501]);
      break;
    }
    case 16: {
      data = make(data, 523, [524, 525]);
      data = make(data, 526, [527, 528]);
      data = make(data, 522, [523, 526]);
      data = make(data, 531, [532, 536, 539]);
      data = make(data, 554, [555, 556]);
      data = make(data, 558, [559, 560, 561]);
      data = make(data, 569, [570, 571, 572, 573]);
      data = make(data, 619, [620, 621]);
      data = make(data, 629, [630, 631, 632, 633, 635, 634]);
      data = make(data, 628, [629, 636, 637, 638]);

      data = make(data, 646, [647, 648, 649]);
      data = make(data, 654, [655, 656]);
      data = make(data, 652, [653, 654]);
      data = make(data, 669, [670, 671]);
      data = make(data, 698, [699, 702]);
      data = make(data, 706, [707, 708, 709]);
      data = make(data, 696, [698, 703, 704, 705, 706, 710, 711, 712]);
      data = make(
        data,
        717,
        [718, 719, 720, 721, 722, 723, 724, 725, 726, 728]
      );
      data = make(data, 730, [731, 732]);
      data = make(data, 729, [730, 733]);
      data = make(data, 735, [736, 737, 738, 739, 740, 741, 742]);
      data = make(data, 743, [733, 671]);
      data = make(data, 734, [735, 743]);
      break;
    }
  }

  return data;
};

const make = (data, i, arr) => {
  let s = 0;
  if (data[i]) {
    arr.map((a) => {
      if (a < 0) {
        a *= -1;
        if (data[a]) {
          s = ayir(s, data[a].suvi);
        }
      } else {
        if (data[a]) {
          s = add(s, data[a].suvi);
        }
      }
      return null;
    });
    if (s % 1 !== 0) s = s.toFixed(1);
    data[i].suvi = s;
  }
  return data;
};

const add = (a, b) => {
  if (!a || typeof a == "undefined" || a === "") {
    a = 0;
  }
  if (!b || typeof b == "undefined" || b === "") {
    b = 0;
  }
  return parseFloat(a) + parseFloat(b);
};

const ayir = (a, b) => {
  if (!a || typeof a == "undefined" || a === "") {
    a = 0;
  }
  if (!b || typeof b == "undefined" || b === "") {
    b = 0;
  }
  return parseFloat(a) - parseFloat(b);
};
